import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

function SkeletonComponent() {
  const objs = [
    [
      {
        name: "Entertainment",
      },
    ],
    [
      {
        name: "Haircuts and personal grooming",
      },
    ],
    [
      {
        name: "Charitable donations/religious expenses",
      },
    ],
    [
      {
        name: "Travel",
      },
    ],
    [
      {
        name: "Dues and subscriptions",
      },
    ],
    [
      {
        name: "Pets",
      },
    ],
    [
      {
        name: "Gifts",
      },
    ],
  ];

  return (
    <>
      {objs.map((obj) => (
        <tr>
          <td>{obj[0].name}</td>
          <td>
            <Skeleton height={18} width={90} variant="text" />
          </td>
          <td>
            <Skeleton height={18} width={90} variant="text" />
          </td>
        </tr>
      ))}
    </>
  );
}

export default SkeletonComponent;
